/* eslint-disable import/extensions */
import { getFontSection, fontSectionEnum } from '../shared-configs/font-section.js';
import { createColorPaletteWidget, createColorPaletteTitleWidget } from '../utils.js';

const entireGraphFontConfig = getFontSection(
	{
		fontName: 'fontFamilyGlobal',
		fontSize: 'fontSizeGlobal',
		fontStyle: 'fontStyleGlobal',
		fontColor: 'fontColorGlobal'
	},
	[fontSectionEnum.NAME_SELECT, fontSectionEnum.STYLE, fontSectionEnum.SIZE_AND_COLOR]
);

const dataLabelFontConfig = getFontSection(
	{
		fontName: 'fontFamilyName',
		fontSize: 'fontSizeName',
		fontStyle: 'fontStyleName',
		fontColor: 'fontColorName'
	},
	[fontSectionEnum.NAME_SELECT, fontSectionEnum.STYLE, fontSectionEnum.SIZE_AND_COLOR]
);

const totalFontConfig = getFontSection(
	{
		fontName: 'fontFamilyTotal',
		fontSize: 'fontSizeTotal',
		fontStyle: 'fontStyleTotal',
		fontColor: 'fontColorTotal'
	},
	[fontSectionEnum.NAME_SELECT, fontSectionEnum.STYLE, fontSectionEnum.SIZE_AND_COLOR]
);

const levelFontConfig = getFontSection(
	{
		fontName: 'fontFamilyLevelName',
		fontSize: 'fontSizeLevelName',
		fontStyle: 'fontStyleLevelName',
		fontColor: 'fontColorLevelName'
	},
	[fontSectionEnum.NAME_SELECT, fontSectionEnum.STYLE, fontSectionEnum.SIZE_AND_COLOR]
);

const entireGraph = {
	tagName: 'VerticalLayout',
	key: 'entireGraphFontConfig',
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: { desc: 'Sankey30', name: 'Font' }
		},
		entireGraphFontConfig,
		{
			tagName: 'Checkbox',
			checked: false,
			key: 'isTextWrapEnabled',
			text: { desc: 'Sankey31', name: 'Wrap Text' }
		}
	]
};

const dataLabel = {
	tagName: 'VerticalLayout',
	key: 'dataLabelFontConfig',
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: { desc: 'Sankey30', name: 'Font' }
		},
		{
			tagName: 'HorizontalLayout',
			className: 'horizontal-flex-space-between',
			children: [
				{
					tagName: 'Text',
					text: { desc: 'Sankey32', name: 'Show data labels' }
				},
				{
					tagName: 'Switch',
					key: 'showName',
					func: {
						type: 'hide',
						targets: ['dataLabelFontConfigHideable']
					}
				}
			]
		},
		{
			tagName: 'VerticalLayout',
			key: 'dataLabelFontConfigHideable',
			children: [dataLabelFontConfig]
		}
	]
};

const total = {
	tagName: 'VerticalLayout',
	key: 'totalFontConfig',
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: { desc: 'Sankey30', name: 'Font' }
		},
		{
			tagName: 'HorizontalLayout',
			className: 'horizontal-flex-space-between',
			children: [
				{
					tagName: 'Text',
					text: { desc: 'Sankey33', name: 'Show total' }
				},
				{
					tagName: 'Switch',
					key: 'showTotal',
					func: {
						type: 'hide',
						targets: ['totalFontConfigHideable']
					}
				}
			]
		},
		{
			tagName: 'VerticalLayout',
			key: 'totalFontConfigHideable',
			children: [totalFontConfig]
		}
	]
};

const level = {
	tagName: 'VerticalLayout',
	key: 'levelFontConfig',
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: { desc: 'Sankey30', name: 'Font' }
		},
		levelFontConfig
	]
};

const node = {
	tagName: 'VerticalLayout',
	key: 'nodeFontConfig',
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: { desc: 'Sankey34', name: 'Shape' }
		},
		{
			tagName: 'Radio',
			horizontal: true,
			className: 'toggle-button-radio _2item',
			key: 'radioForNodeColorPalettes',
			options: [
				{ name: { desc: 'Sankey14', name: 'Nodes' }, value: 'nodes' },
				{ name: { desc: 'Sankey35', name: 'Grouped' }, value: 'groupedNodes' }
			],
			useButtons: true
		},
		{
			tagName: 'VerticalLayout',
			key: 'nodeColorPaletteContainer',
			children: [
				createColorPaletteTitleWidget('nodeColorPaletteTitle'),
				createColorPaletteWidget('nodeColorPalette')
			]
		},
		{
			tagName: 'ColorPicker',
			key: 'groupedNodeColor'
		}
	]
};

const flow = {
	tagName: 'VerticalLayout',
	key: 'flowFontConfig',
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: { desc: 'Sankey34', name: 'Shape' }
		},
		{
			tagName: 'Select',
			key: 'flowFillType',
			options: [
				{ name: { desc: 'Sankey36', name: 'Solid' }, value: 'solid' },
				{ name: { desc: 'Sankey37', name: 'Color from source' }, value: 'fromSource' },
				{ name: { desc: 'Sankey38', name: 'Color from target' }, value: 'fromTarget' },
				{ name: { desc: 'Sankey39', name: 'Gradient' }, value: 'gradient' }
			]
		},
		{
			tagName: 'HorizontalLayout',
			className: 'horizontal-flex-space-between _3item-stretch',
			children: [
				{
					tagName: 'Text',
					text: { desc: 'Sankey40', name: 'Fill' }
				},
				{
					tagName: 'ColorPicker',
					key: 'flowFillColor',
					className: 'sankey__flow-color-picker'
				},
				{
					tagName: 'InputNumber',
					value: 100,
					format: ' %',
					min: 0,
					max: 100,
					key: 'flowOpacityPercent',
					showStepper: false,
					applyChangeOnFocusOut: false
				}
			]
		}
	]
};

const textAndFormConfig = {
	tagName: 'SegmentControlDropdownMenu',
	optionDisplayNames: [
		{ desc: 'Sankey41', name: 'Entire Graph' },
		{ desc: 'Sankey42', name: 'Data Label' },
		{ desc: 'Sankey22', name: 'Total' },
		{ desc: 'Sankey21', name: 'Level' },
		{ desc: 'Sankey20', name: 'Node' },
		{ desc: 'Sankey50', name: 'Flows' }
	],
	key: 'sankeySpecificFontAndColorProperties',
	children: [entireGraph, dataLabel, total, level, node, flow]
};

export default textAndFormConfig;
